import { render, staticRenderFns } from "./NghiPhep.vue?vue&type=template&id=2c414bfa&scoped=true"
import script from "./NghiPhep.vue?vue&type=script&lang=js"
export * from "./NghiPhep.vue?vue&type=script&lang=js"
import style0 from "./NghiPhep.vue?vue&type=style&index=0&id=2c414bfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c414bfa",
  null
  
)

export default component.exports